import DateRangePicker from './dateRangePicker.component';

export * from './dateRangePicker.types';
export default DateRangePicker;
